<div class="invoices-page">
  <h1>{{ 'account.invoice.page.title' | translate }}</h1>
  <div class="filters">
    <div class="filter-group-temp">
      <label for="invoice-number">Invoice Number</label>
      <input
        #invoiceNumberInput
        type="text"
        id="invoice-number"
        placeholder="Enter Invoice Number"
        (input)="searchInvoices($event)"
      />
    </div>
    <div class="filter-group-temp">
      <label for="transaction-date-from">Transaction Date From</label>
      <input type="date" id="transaction-date-from" (change)="onTransactionDateFromChange($event)" />
    </div>
    <div class="filter-group-temp">
      <label for="transaction-date-to">Transaction Date To</label>
      <input type="date" id="transaction-date-to" (change)="onTransactionDateToChange($event)" />
    </div>
    <div class="filter-group-temp">
      <label for="payment-status">Payment Status</label>
      <select id="payment-status" (change)="onPaymentStatusChange($event)">
        <option value="all">All</option>
        <option value="paid">Paid</option>
        <option value="unpaid">Unpaid</option>
      </select>
    </div>
    <div class="filter-buttons">
      <button class="button-rounded search-invoices" (click)="onInvoiceNumberInput(invoiceNumberInput.value)">
        Search Invoices
      </button>
      <button class="button-rounded clear-search" (click)="clearSearch()">Clear Search</button>
    </div>
  </div>

  <div class="invoices-table">
    <table>
      <thead>
        <tr>
          <th>#</th>
          <th>Invoice #</th>
          <th>Transaction Date</th>
          <th>Due Date</th>
          <th>Days Overdue</th>
          <th>Amount</th>
          <th>Payment Amount</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let invoice of filteredInvoices">
          <td><input type="checkbox" /></td>
          <td>
            <a href="#">{{ invoice.id }}</a>
          </td>
          <td>{{ invoice.transactionDate }}</td>
          <td>{{ invoice.dueDate }}</td>
          <td>{{ invoice.daysOverdue }}</td>
          <td>$ {{ invoice.amount.toFixed(2) }}</td>
          <td><input type="text" value="$0.00" /></td>
        </tr>
      </tbody>
    </table>
    <p class="note">
      * Payment of past due balances by credit card will be subjected to a 2.5% surcharge that will be applied against
      the past due balances only.
    </p>
    <button class="button-rounded make-payment">Make a Payment</button>
  </div>
</div>
